/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { ParserContext, Term } = require('@cedalo/parser');
const MessageBoxReference = require('./MessageBoxReference');
const ReferenceFactory = require('./ReferenceFactory');
const SheetReference = require('./SheetReference');

const refTermFromStr = (str, scope) => {
	let operand =
		SheetReference.fromString(scope.sheet, str.toUpperCase()) ||
		MessageBoxReference.fromString(scope.sheet, str.toUpperCase());
	if (operand) {
		const term = new Term();
		term.defstr = str;
		term.operand = operand;
		return term;
	}

	if (scope.item) {
		operand = ReferenceFactory.fromString(str, scope.graph, scope.item);
		if (operand) {
			const term = new Term();
			term.defstr = str;
			term.operand = operand;
			return term;
		}
	}
	return undefined;
};

module.exports = class GraphParserContext extends ParserContext {
	constructor() {
		super({});
		this.hints.largePosIntToString = true;
	}

	// to clear scope, call without any parameter or pass undefined...
	setScope(scope) {
		// always create new scope, because context is shared during parsing different formula...
		this.scope = scope;
	}

	// node: is a parser AST node
	// return a reference term or undefined...
	createReferenceTerm(node /* , parent */) {
		// is string still relevant?
		return node.type === 'identifier' && refTermFromStr(node.value, this.scope);
	}
};
